export default "__VITE_ASSET__ebecf2f5__"